import Vue from "vue";
import App from "./App.vue";
import Vuex from "vuex";
import Buefy from "buefy";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import fontawesome from "@/plugins/fontawesome.js";
import VueFullscreen from "vue-fullscreen";
import banner from "rollup-plugin-banner";
import store from "@/store";

Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(fontawesome);

Vue.use(Buefy, {
  defaultIconComponent: FontAwesomeIcon,
  defaultIconPack: "fas",
});
Vue.use(VueFullscreen);

const root_element = document.getElementById("transkribusEditor");
const AppRoot = Vue.extend(App);


window.eventBus = new AppRoot({
  store,
  el: root_element,
  propsData: { ...root_element.dataset },
  mounted() {
    this.$root.$on("save", this.save);
    const that = this;
    this.$root.$on("change", function (payLoad) {
      if (payLoad.iiifUrl) {
        that.$store.dispatch("content/setIIIF", {
          iiifUrl: payLoad.iiifUrl,
        });
      }
      if (payLoad.xmlJsonString) {
        var cleanedString = this.escapeSpecialChars(payLoad.xmlJsonString);
        const obj = JSON.parse(cleanedString);
        that.$store.dispatch("content/setXmlJson", {
          xmlJson: obj,
        });
      }
      if (payLoad.xml) {
        that.$store.dispatch("content/setXml", {
          xml: payLoad.xml,
        });
      }
    });
  },
  methods: {
    save(value) {
      window.output = value;
      root_element.dataset.output = JSON.stringify(value);
      window.eventBus.$emit("dataSaved", value);
    },
    escapeSpecialChars(string) {
      return string
        .replace(/\\n/g, "\\n")
        .replace(/\\'/g, "\\'")
        .replace(/\\"/g, '\\"')
        .replace(/\\&/g, "\\&")
        .replace(/\\r/g, "\\r")
        .replace(/\\t/g, "\\t")
        .replace(/\\b/g, "\\b")
        .replace(/\\f/g, "\\f");
    },
  },
}).$mount("#transkribusEditor");

export default AppRoot;
